module.exports = __webpack_public_path__ + "static/img/syfl-2.e380623d.jpg";